import axios from "axios";
import { BACKEND } from "../../config/configEnvs";
const getActiveWorkers = async (setData, extaQuery = "") => {
  try {
    const response = await axios.get(`${BACKEND}/api/trabajadores?limit=0&where[activo][equals]=true&select=name,sueldo,id${extaQuery}`);
    setData(response.data.docs);
  } catch (error) {
    return false
  }
}

export default getActiveWorkers;

